import { LogEntry } from '../../types';
import type { DbClient } from './types';

/**
 * Persiste log de auditoria vinculado à empresa ativa.
 * @param sb - Cliente Postgres
 * @param log - Entrada de log
 * @param companyId - UUID da empresa
 */
export async function addLog(sb: DbClient, log: LogEntry, companyId: string): Promise<void> {
  const isUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-/.test(log.userId);
  const { error } = await sb.from('rh_logs').insert({
    company_id: companyId,
    user_id: isUuid ? log.userId : null,
    username: log.username,
    action: log.action,
    details: log.details,
    created_at: log.timestamp,
  });
  if (error) console.warn('[rh_logs] Erro ao salvar log:', error.message);
}

/**
 * Lista os últimos logs de uma empresa (máx. 1000).
 * @param sb - Cliente Postgres
 * @param companyId - UUID da empresa
 */
export async function loadLogs(sb: DbClient, companyId: string): Promise<LogEntry[]> {
  const { data, error } = await sb
    .from('rh_logs')
    .select('*')
    .eq('company_id', companyId)
    .order('created_at', { ascending: false })
    .limit(1000);
  if (error) return [];
  return (data ?? []).map((row: Record<string, unknown>) => ({
    id: String(row.id),
    userId: row.user_id != null ? String(row.user_id) : '',
    username: String(row.username),
    timestamp: String(row.created_at),
    action: String(row.action),
    details: String(row.details),
    companyId: row.company_id != null ? String(row.company_id) : undefined,
  }));
}
